// Router-Root mit Login-Gate.
// Solange /api/auth/me kein User liefert, zeigt App die LoginPage —
// keine Routen, kein Layout drumherum. Sobald eingeloggt: Dashboard
// & Co. via Layout + <Outlet/>.

import { Route, Routes } from "react-router-dom";

import { useCurrentUser } from "@/api/hooks";
import { Layout } from "@/components/Layout";
import { Loader } from "@/components/Loader";
import { AdminPage } from "@/pages/AdminPage";
import { BelegDetailPage } from "@/pages/BelegDetail";
import { Dashboard } from "@/pages/Dashboard";
import { LoginPage } from "@/pages/LoginPage";
import { MandantenPage } from "@/pages/MandantenPage";
import { SettingsPage } from "@/pages/SettingsPage";
import { UploadPage } from "@/pages/UploadPage";

export default function App() {
  const me = useCurrentUser();

  if (me.isLoading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Loader label="Anmeldung wird geprüft…" />
      </div>
    );
  }

  if (!me.data) {
    return <LoginPage />;
  }

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path="/belege/:id" element={<BelegDetailPage />} />
        <Route path="/upload" element={<UploadPage />} />
        <Route path="/mandanten" element={<MandantenPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/einstellungen" element={<SettingsPage />} />
        <Route
          path="*"
          element={
            <div className="bmd-card">
              <h2>404 — Seite nicht gefunden</h2>
              <p className="bmd-muted">
                Diese Route existiert in der Fidena-Oberfläche nicht.
              </p>
            </div>
          }
        />
      </Route>
    </Routes>
  );
}
